import { Box, Button, Flex, Link } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UI } from 'src/apps/invest/common/shells/UI';
import { useInboxModel } from '../../../../../common/models/InboxModel';
import { useInvestorAccountModel } from '../../../../../common/models/InvestorAccountModel';
import { TextBlock } from '../../../common/components/TextBlock';
import { ROUTES } from '../../../config';
import { useInboxViewModel } from '../../models/InboxViewModel';

const iconSize = {
  desktop: 80,
  mobile: 60,
};

type ResendButtonState = 'RESEND_EMAIL' | 'PROCESSING' | 'BACK_TO_ALERTS';

export const VerifyEmail: React.FC = () => {
  const [buttonState, setButtonState] = useState<ResendButtonState>('RESEND_EMAIL');
  const model = useInboxViewModel();
  const investorModel = useInvestorAccountModel();
  const inboxModel = useInboxModel();
  const navigate = useNavigate();

  return (
    <UI>
      <Flex flex={1} alignItems="center" justifyContent={'center'}>
        <Flex flexDirection={'column'} alignItems={'center'} maxWidth={350}>
          <Box
            w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            position="relative">
            <Box
              bgColor={'orange.50'}
              w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
              h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
              position="absolute"
              borderRadius={[iconSize.mobile, iconSize.desktop]}></Box>
            <Box
              bgColor={['transparent', 'orange.100']}
              opacity={0.5}
              w={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
              h={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
              position="absolute"
              borderRadius={60}
              top={[
                (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
                (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
              ]}
              left={[
                (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
                (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
              ]}></Box>
            <Icon
              icon={'at'}
              boxSize={[iconSize.mobile * 0.3 + 'px', iconSize.desktop * 0.3 + 'px']}
              color={'orange.300'}
              top={[
                (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
                (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
              ]}
              left={[
                (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
                (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
              ]}
              position="absolute"
            />
          </Box>
          <TextBlock textAlign="center" mt={'20px'} fontSize={'24px'} weight="bold">
            Unverified Email Address
          </TextBlock>
          <TextBlock textAlign="center" mt={'20px'}>
            Your email address is not verified. If your email address is correct, please resend a verification email.
          </TextBlock>
          <TextBlock mt={'20px'} weight="bold">
            {investorModel.investorAccount?.email}
          </TextBlock>

          <Button
            w={'300px'}
            isLoading={buttonState === 'PROCESSING'}
            onClick={async () => {
              if (buttonState === 'RESEND_EMAIL') {
                setButtonState('PROCESSING');
                const status = await model.resendEmail();
                if (status.success) {
                  setButtonState('BACK_TO_ALERTS');
                } else {
                  alert('Something went wrong resending email. Please try again.');
                  setButtonState('RESEND_EMAIL');
                }
              }

              if (buttonState === 'BACK_TO_ALERTS') {
                setButtonState('PROCESSING');
                const res = await investorModel.fetchInvestorAccount();
                inboxModel.checkForAlerts(res.investorAccount);

                navigate(ROUTES.inbox);
              }
            }}
            mt={'20px'}>
            {buttonState === 'RESEND_EMAIL' ? 'Resend Verification Email' : 'Refresh'}
          </Button>
          <TextBlock textAlign="center" mt={'36px'}>
            If you need to change your email address, please use the{' '}
            <Link fontFamily={FontFamily.HELVETICA_NOW_BOLD} href={ROUTES.accountInformation}>
              account information page
            </Link>
            .
          </TextBlock>
        </Flex>
      </Flex>
    </UI>
  );
};
